import { FileSystemItemModel } from "./webDav";
import { NewDocumentType } from "client/Api/Documents/common";
import { environmentHttpClient } from "client/Api/httpClient";

export function deleteItems(
	serverId: number,
	itemIds: readonly string[],
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.post<void>(
		`Documents/WebDav/${serverId}/Delete`,
		itemIds,
		{ signal }
	);
}

export type CreateFolderModel = {
	folderId: string;
	name: string | null;
};

export function createFolder(
	serverId: number,
	model: CreateFolderModel,
	signal?: AbortSignal
): Promise<FileSystemItemModel> {

	return environmentHttpClient.post<FileSystemItemModel>(
		"Documents/WebDav/" + serverId + "/CreateFolder",
		model,
		{ signal }
	);
}

export type CreateDocumentModel = {
	folderId: string;
	documentType: NewDocumentType;
	name: string | null;
};

export function createDocument(
	serverId: number,
	model: CreateDocumentModel,
	signal?: AbortSignal
): Promise<FileSystemItemModel> {
	return environmentHttpClient.post<FileSystemItemModel>(
		`Documents/WebDav/${serverId}/CreateDocument`,
		model,
		{ signal }
	);
}

export type RenameModel = {
	itemId: string;
	name: string;
};

export function rename(
	serverId: number,
	model: RenameModel,
	signal?: AbortSignal
): Promise<FileSystemItemModel> {
	return environmentHttpClient.put<FileSystemItemModel>(
		`Documents/WebDav/${serverId}/Rename`,
		model,
		{ signal }
	);
}

export interface IMoveResult {
	failedItems: string[];
	movedItems: {
		[itemId: string]: FileSystemItemModel;
	};
}

export function move(
	serverId: number,
	itemIds: string[],
	destinationFolderId: string,
	signal?: AbortSignal
): Promise<IMoveResult> {
	return environmentHttpClient.put<IMoveResult>(
		`Documents/WebDav/${serverId}/Move`,
		{
			destinationFolderId: destinationFolderId,
			itemIds: itemIds
		},
		{ signal }
	);
}

export interface CopyModel {
	fileId: string;
	name: string | null;
	destinationServerId: number;
	destinationFolderId: string;
}

export function copy(
	serverId: number,
	model: CopyModel,
	signal?: AbortSignal
): Promise<FileSystemItemModel> {
	return environmentHttpClient.post<FileSystemItemModel>(
		`Documents/WebDav/${serverId}/Copy`,
		model,
		{ signal }
	);
}
